<div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
  <h4 class="form-modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="closePopup()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="form-modal-body p-3 internaldeficicencysection">
  <formio [submission]="submittedData" [form]="formJson" [renderOptions]="renderOptions" (submit)="onSubmit($event)"
    [readOnly]="viewForm" [options]="formOptions" #formIO>
  </formio>
</div>

<div class="form-modal-footer p-3 formio-modal-footer">
  <div class="justify-content-center modal-actions">
    <button class="btn-cancel btn btn-primary btn-lg "  *ngIf="action !== 'Update'"  (click)="closePopup()">Close</button>
    <button class="btn-cancel btn btn-primary btn-lg "
            *ngIf="action === 'Update'"
            [disabled]="isResetButtonDisabled"
            [class.disabled]="isResetButtonDisabled"
            (click)="resetForm()">Reset</button>
    <button lang="en" class="btn btn-primary btn-lg " *ngIf="!viewForm" type="submit" name="data[submit]" (click)="onSubmit(submittedData)"
      ref="button">{{action}}</button>
  </div>
</div>
